import React, { useState } from 'react';
import { Input, Form, InputNumber, Select, Modal, Button, Spin, notification } from 'antd';
import { Pass, allPriceUnitsTypes, allVehiculeTypes } from '../../../shared/types';
import { handleFormChange, layoutEdit, validateMessages } from '../../../shared/Utils';
import { useCreatePassMutation } from '../../../GraphQL/hooks/useCreatePassMutation';

const PassCreateModal = ({ isOpen, onRequestClose, updateList }) => {
    const [form] = Form.useForm();
    const [formError, setFormError] = useState(false);

    const { mutation, loading: creating } = useCreatePassMutation();

    const handleCommit = async () => {
        try {
            const values = await form.validateFields();
            if (values) {
                mutation({ ...values })
                    .then(() => {
                        onRequestClose(false);
                        updateList();
                    })
                    .finally(() => {
                        notification.success({
                            message: 'Pass updated successfully',
                            description: 'The pass has been updated successfully.',
                        });
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Failed to update pass',
                            description: 'An error occurred while updating the pass.',
                        });

                        console.error('Failed to update pass:', err);
                    });
            }
        } catch (errorInfo) {
            notification.error({
                message: 'Form validation failed',
                description: 'Please check the form for errors and try again.',
            });
            console.error('Form validation failed:', errorInfo);
        }
    };

    const handleCancel = () => {
        onRequestClose(false);
    };

    return (
        <Modal
            forceRender
            title="Add Pass"
            open={isOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="create" type="primary" onClick={handleCommit} disabled={formError}>
                    Create
                </Button>,
            ]}
        >
            <Spin spinning={creating}>
                <Form<Pass>
                    {...layoutEdit}
                    form={form}
                    name="nest-messages"
                    autoComplete="off"
                    onFieldsChange={() => {
                        setFormError(handleFormChange(form));
                    }}
                    validateMessages={validateMessages}
                >
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input type="textarea" placeholder="Name of the pass" style={{ width: '60%' }} />
                    </Form.Item>
                    <Form.Item name="note" label="Note" rules={[{ required: true }]}>
                        <Input type="textarea" placeholder="Description of the pass" style={{ width: '60%' }} />
                    </Form.Item>
                    <Form.Item name="initialPrice" label="Initial price" rules={[{ required: true }]}>
                        <InputNumber type="number" placeholder="Initial pass price" style={{ width: '50%' }} />
                    </Form.Item>
                    <Form.Item name="priceUnit" label="Price unit" rules={[{ required: true }]}>
                        <Select placeholder="Select price unit" style={{ width: '60%' }}>
                            {(allPriceUnitsTypes ?? []).map((type) => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="discount" label="Discount" rules={[{ required: true }]}>
                        <InputNumber type="number" placeholder="Discounted pourcent %" style={{ width: '50%' }} />
                    </Form.Item>
                    <Form.Item name="duration" label="Duration" rules={[{ required: true }]}>
                        <InputNumber type="number" placeholder="Duration" />
                    </Form.Item>
                    <Form.Item name="unlockPrice" label="Unlock price" rules={[{ required: true }]}>
                        <InputNumber type="number" placeholder="Unlock price" />
                    </Form.Item>
                    <Form.Item name="minutePrice" label="Minute price" rules={[{ required: true }]}>
                        <InputNumber type="number" placeholder="Minute price" />
                    </Form.Item>
                    <Form.Item name="vehiculeType" label="Vehicule type" rules={[{ required: true }]}>
                        <Select placeholder="Select type of vehicule" style={{ width: '60%' }}>
                            {(allVehiculeTypes ?? []).map((type) => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
};

export default PassCreateModal;
